// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-criminal-grid-evictions .settingsContainer {
  display: flex;
  flex-direction: row;
  padding-left: 150px;
}
app-criminal-grid-evictions .settingsContainer .radio-row {
  display: inline-flex;
  flex-direction: column !important;
}
app-criminal-grid-evictions .settingsContainer .radio-row .radio-faux-label {
  font-weight: 600;
  padding-left: 15px;
  padding-bottom: 10px;
}
app-criminal-grid-evictions .settingsContainer .radio-row .radio-faux-label-text {
  font-weight: 600;
}
app-criminal-grid-evictions .settingsContainer .defaultSettingContainer {
  flex: 0 1 180px;
}
app-criminal-grid-evictions .settingsContainer .offsenseNameContainer {
  flex: 0 1 40%;
  font-weight: 600;
}
app-criminal-grid-evictions .settingsContainer .howManyAllowedContainer {
  flex: 0 1 280px;
}
app-criminal-grid-evictions .settingsContainer .howManyAllowedContainer .mat-radio-button {
  padding-right: 10px;
}
app-criminal-grid-evictions .settingsContainer .howManyAllowedContainer .mat-radio-button .mat-radio-label {
  font-weight: 600;
}
app-criminal-grid-evictions .settingsContainer .howManyAllowedContainer .mat-radio-label {
  margin-bottom: 0 !important;
}
app-criminal-grid-evictions .settingsContainer .howLongContainer {
  flex: 0 1 190px;
}
app-criminal-grid-evictions .settingsContainer .howLongContainer .howLongInput {
  width: 50px;
}
app-criminal-grid-evictions .settingsContainer .howLongContainer .yearsLabel {
  font-weight: 600;
  padding-left: 10px;
}
app-criminal-grid-evictions .settingsContainer .decisionContainer {
  flex: 0 1 270px;
}
app-criminal-grid-evictions .settingsContainer .decisionContainer .radio-row {
  padding-right: 15px;
  text-align: center;
}
app-criminal-grid-evictions .settingsContainer .buttonContainer {
  flex: 0 1 70px;
}
app-criminal-grid-evictions .settingsContainer .buttonContainer .propertyOverrideLabel {
  font-size: 11px;
}
app-criminal-grid-evictions .settingsContainer .buttonContainer .saveButton {
  background-color: green;
}
app-criminal-grid-evictions .masterCrimeContainer {
  display: flex;
  flex-direction: column;
}
app-criminal-grid-evictions .masterCrimeContainer .settingsReadout {
  padding: 5px;
  background-color: #f7ebef;
  margin-right: 50px;
}
app-criminal-grid-evictions .masterCrimeContainer .settingsReadout .description {
  font-weight: bold;
}
app-criminal-grid-evictions .masterCrimeContainer .settingsReadout .highlightedBlock {
  padding-left: 5px;
  padding-right: 5px;
  color: blue;
  text-decoration: underline;
  text-transform: capitalize;
}
app-criminal-grid-evictions .propertyOverrideContainer {
  background-color: aquamarine;
  border: none;
  margin-top: 12px;
  padding-top: 16px;
  padding-bottom: 0px;
}
app-criminal-grid-evictions .propertyOverrideContainer .buttonContainer {
  flex: 0 1 70px;
}
app-criminal-grid-evictions .propertyOverrideContainer .buttonContainer .propertyOverrideSaveButton {
  background-color: green;
}
app-criminal-grid-evictions .propertyOverrideContainer .buttonContainer .propertyOverrideDeleteButton {
  background-color: red;
}
app-criminal-grid-evictions .propertyOverrideContainerResults {
  background-color: aquamarine;
  padding-bottom: 7px;
}
app-criminal-grid-evictions .propertyOverrideContainerResults .settingsReadout {
  padding: 5px;
  background-color: #f7ebef;
}
app-criminal-grid-evictions .propertyOverrideContainerResults .settingsReadout .description {
  font-weight: bold;
}
app-criminal-grid-evictions .propertyOverrideContainerResults .settingsReadout .highlightedBlock {
  padding-left: 5px;
  padding-right: 5px;
  color: blue;
  text-decoration: underline;
  text-transform: capitalize;
}
app-criminal-grid-evictions .mat-radio-label {
  flex-direction: column;
}
app-criminal-grid-evictions .mat-radio-label .mat-radio-label-content {
  padding: 10px;
}
app-criminal-grid-evictions .settingsContainer {
  border-top: 1px solid;
  padding-top: 20px;
  padding-bottom: 2px;
}
app-criminal-grid-evictions .mat-tab-label {
  background-color: #e6e4e6;
  width: 50%;
}
app-criminal-grid-evictions .gridHeaderContainer {
  display: flex;
  flex-direction: row;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 150px;
}
app-criminal-grid-evictions .gridHeaderContainer .headerContainer {
  font-weight: 600;
}
app-criminal-grid-evictions .gridHeaderContainer .defaultSettingHeader {
  flex: 0 1 180px;
}
app-criminal-grid-evictions .gridHeaderContainer .offsenseNameHeader {
  flex: 0 1 40%;
}
app-criminal-grid-evictions .gridHeaderContainer .howManyAllowedHeader {
  flex: 0 1 280px;
}
app-criminal-grid-evictions .gridHeaderContainer .howLongHeader {
  flex: 0 1 190px;
}
app-criminal-grid-evictions .gridHeaderContainer .decisionHeader {
  flex: 0 1 270px;
}
app-criminal-grid-evictions .gridHeaderContainer .buttonHeader {
  flex: 0 1 70px;
}
app-criminal-grid-evictions .button-row {
  position: static !important;
}
app-criminal-grid-evictions .propertyOverrideContainer {
  background-color: aquamarine;
  border: none;
  margin-top: 12px;
  padding-top: 16px;
  padding-bottom: 0px;
}
app-criminal-grid-evictions .propertyOverrideContainer .buttonContainer {
  flex: 0 1 70px;
}
app-criminal-grid-evictions .propertyOverrideContainer .buttonContainer .propertyOverrideSaveButton {
  background-color: green;
}
app-criminal-grid-evictions .propertyOverrideContainer .buttonContainer .propertyOverrideDeleteButton {
  background-color: red;
}
`, "",{"version":3,"sources":["webpack://./src/app/decision-grid/Components/criminal-grid-evictions/criminal-grid-evictions.component.less"],"names":[],"mappings":"AAAA;EAII,aAAA;EACA,mBAAA;EACA,mBAAA;AAFJ;AAJA;EASM,oBAAA;EACA,iCAAA;AAFN;AARA;EAaQ,gBAAA;EACA,kBAAA;EACA,oBAAA;AAFR;AAbA;EAkBQ,gBAAA;AAFR;AAhBA;EAuBM,eAAA;AAJN;AAnBA;EA4BM,aAAA;EACA,gBAAA;AANN;AAvBA;EAiCM,eAAA;AAPN;AA1BA;EAoCQ,mBAAA;AAPR;AA7BA;EAuCU,gBAAA;AAPV;AAhCA;EA4CQ,2BAAA;AATR;AAnCA;EAiDM,eAAA;AAXN;AAtCA;EAoDQ,WAAA;AAXR;AAzCA;EAwDQ,gBAAA;EACA,kBAAA;AAZR;AA7CA;EA8DM,eAAA;AAdN;AAhDA;EAiEQ,mBAAA;EACA,kBAAA;AAdR;AApDA;EA+EM,cAAA;AAxBN;AAvDA;EAkFQ,eAAA;AAxBR;AA1DA;EAsFQ,uBAAA;AAzBR;AA7DA;EA8FI,aAAA;EACA,sBAAA;AA9BJ;AAjEA;EAiGM,YAAA;EACA,yBAAA;EACA,kBAAA;AA7BN;AAtEA;EAsGQ,iBAAA;AA7BR;AAgCM;EACE,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,0BAAA;EACA,0BAAA;AA9BR;AAhFA;EAoHI,4BAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAjCJ;AAvFA;EA6HM,cAAA;AAnCN;AA1FA;EAgIQ,uBAAA;AAnCR;AA7FA;EAoIQ,qBAAA;AApCR;AAyCE;EAEE,4BAAA;EACA,mBAAA;AAxCJ;AA0CI;EACE,YAAA;EACA,yBAAA;AAxCN;AAsCI;EAKI,iBAAA;AAxCR;AA2CM;EACE,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,0BAAA;EACA,0BAAA;AAzCR;AAlHA;EAmKI,sBAAA;AA9CJ;AArHA;EAsKM,aAAA;AA9CN;AAxHA;EA6KI,qBAAA;EAGA,iBAAA;EACA,mBAAA;AApDJ;AA7HA;EAsLI,yBAAA;EACA,UAAA;AAtDJ;AAjIA;EA6LI,aAAA;EACA,mBAAA;EAEA,iBAAA;EACA,oBAAA;EACA,mBAAA;AA1DJ;AAxIA;EAqMM,gBAAA;AA1DN;AA3IA;EAyMM,eAAA;AA3DN;AA9IA;EA8MM,aAAA;AA7DN;AAjJA;EAkNM,eAAA;AA9DN;AApJA;EAsNM,eAAA;AA/DN;AAvJA;EA0NM,eAAA;AAhEN;AA1JA;EA8NM,cAAA;AAjEN;AA7JA;EAmOI,2BAAA;AAnEJ;AAhKA;EAuOI,4BAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AApEJ;AAvKA;EAgPM,cAAA;AAtEN;AA1KA;EAmPQ,uBAAA;AAtER;AA7KA;EAuPQ,qBAAA;AAvER","sourcesContent":["app-criminal-grid-evictions {\n\n  .settingsContainer {\n\n    display: flex;\n    flex-direction: row;\n    padding-left: 150px;\n\n    .radio-row {\n      display: inline-flex;\n      flex-direction: column !important;\n      \n      .radio-faux-label {\n        font-weight: 600;\n        padding-left: 15px;\n        padding-bottom: 10px;\n      }\n      .radio-faux-label-text {\n        font-weight: 600;\n      }\n    }\n\n    .defaultSettingContainer {\n      flex: 0 1 180px;\n    }\n\n    .offsenseNameContainer {\n      // flex: 1;\n      flex: 0 1 40%;\n      font-weight: 600;\n    }\n\n    .howManyAllowedContainer {\n      flex: 0 1 280px;\n\n      .mat-radio-button {\n        padding-right: 10px;\n\n        .mat-radio-label {\n          font-weight: 600;\n        }\n      }\n\n      .mat-radio-label {\n        margin-bottom: 0 !important;\n      }\n    }\n\n    .howLongContainer {\n      flex: 0 1 190px;\n\n      .howLongInput {\n        width: 50px;\n      }\n\n      .yearsLabel {\n        font-weight: 600;\n        padding-left: 10px;\n      }\n    }\n\n    .decisionContainer {\n      flex: 0 1 270px;\n\n      .radio-row {\n        padding-right: 15px; \n        text-align: center;\n      }\n\n      // .mat-radio-button {\n      //   padding-right: 12px;\n\n      //   .mat-radio-label {\n      //     font-weight: 600;\n      //   }\n      // }\n    }\n\n    .buttonContainer {\n      flex: 0 1 70px;\n\n      .propertyOverrideLabel {\n        font-size: 11px;\n      }\n\n      .saveButton {\n        background-color: green;\n      }\n    }\n  }\n\n  .masterCrimeContainer {\n\n    \n    display: flex;\n    flex-direction: column;\n    .settingsReadout {\n      padding: 5px;\n      background-color: #f7ebef;\n      margin-right: 50px;\n\n      .description {\n        font-weight: bold;\n      }\n\n      & .highlightedBlock {\n        padding-left: 5px;\n        padding-right: 5px;\n        color: blue;\n        text-decoration: underline;\n        text-transform: capitalize;\n      }\n    }\n  }\n\n  .propertyOverrideContainer {\n    background-color: aquamarine;\n    border: none;\n    margin-top: 12px;\n    padding-top: 16px;\n    padding-bottom: 0px;\n    // margin-left: 20px;\n    // padding-left: 20px;\n\n    .buttonContainer {\n      flex: 0 1 70px;\n\n      .propertyOverrideSaveButton {\n        background-color: green;\n      }\n\n      .propertyOverrideDeleteButton {\n        background-color: red;\n      }\n    }\n  }\n\n  & .propertyOverrideContainerResults {\n\n    background-color: aquamarine;\n    padding-bottom: 7px;\n\n    & .settingsReadout {\n      padding: 5px;\n      background-color: #f7ebef;\n\n      .description {\n        font-weight: bold;\n      }\n\n      & .highlightedBlock {\n        padding-left: 5px;\n        padding-right: 5px;\n        color: blue;\n        text-decoration: underline;\n        text-transform: capitalize;\n      }\n    }\n  }\n\n\n  // Put the radio button labels underneath\n  .mat-radio-label {\n    flex-direction: column;\n\n    .mat-radio-label-content {\n      padding: 10px;\n    }\n  }\n\n\n\n  .settingsContainer {\n    border-top: 1px solid;\n    // border-bottom: 1px solid;\n\n    padding-top: 20px;\n    padding-bottom: 2px;\n\n  }\n\n  .mat-tab-label {\n    background-color: #e6e4e6;\n    width: 50%;\n  }\n\n  .gridHeaderContainer {\n\n    \n    display: flex;\n    flex-direction: row;\n\n    padding-top: 20px;\n    padding-bottom: 20px;\n    padding-left: 150px;\n\n    .headerContainer {\n      font-weight: 600;\n    }\n\n    .defaultSettingHeader {\n      flex: 0 1 180px;\n    }\n\n    .offsenseNameHeader {\n      // flex: 1;\n      flex: 0 1 40%;\n    }\n\n    .howManyAllowedHeader {\n      flex: 0 1 280px;\n    }\n\n    .howLongHeader {\n      flex: 0 1 190px;\n    }\n\n    .decisionHeader {\n      flex: 0 1 270px;\n    }\n\n    .buttonHeader {\n      flex: 0 1 70px;\n    }\n  }\n\n  .button-row {\n    position: static !important;\n  }\n\n  .propertyOverrideContainer {\n    background-color: aquamarine;\n    border: none;\n    margin-top: 12px;\n    padding-top: 16px;\n    padding-bottom: 0px;\n    // margin-left: 20px;\n    // padding-left: 20px;\n\n    .buttonContainer {\n      flex: 0 1 70px;\n\n      .propertyOverrideSaveButton {\n        background-color: green;\n      }\n\n      .propertyOverrideDeleteButton {\n        background-color: red;\n      }\n    }\n  }\n\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
